import { useEffect, useRef, useState } from "react";
import styles from "./SingleTabEnforce.module.css";
import {
  getData
} from "../../utils/GlobalHelper";

function SingleTabEnforcer({ jumpPage }) {
  const [isBlocked, setIsBlocked] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const state_url = urlParams.get("state") || "";
  const refId_url = urlParams.get("refId") || "";
  const refId = getData("refId");
  const state = getData("state");
  // useEffect ตัวแรก ดูแลกรณี jumpPage === false
  useEffect(() => {
    if (jumpPage === false) {
      setIsBlocked(false);
    } else {
      setIsBlocked(true);
    }
  }, [jumpPage]);

  // useEffect ตัวที่สอง ดูแลกรณี jumpPage === true
  useEffect(() => {
    if (jumpPage === true) {
      setIsBlocked(true);
    }
  }, [jumpPage]);
  useEffect(() => {
    if (refId_url && refId.trim() !== decodeURIComponent(refId_url).trim()) {
      setIsBlocked(true);
    }
    if (state_url && state.trim() !== decodeURIComponent(state_url).trim()) {
      setIsBlocked(true);
    }
  }, [refId_url, refId, state_url, state]);

  return isBlocked ? (
    <div className={styles.blockbanner}>
    </div>
  ) : null;
}

export default SingleTabEnforcer;
